import { NAV_STYLE, THEME_COLOR, THEME_TYPE } from "../../constants/ThemeSetting";

export function setIsNavVisible(isNavVisible) {
   return { type: "SET_IS_NAV_VISIBLE", isNavVisible };
}
export function setPlannerSettings(plannerSettings) {
   return { type: "SET_PLANNER_SETTINGS", plannerSettings };
}

export function setIsNewMessage(isNewMessage) {
   return { type: "SET_IS_NEW_MESSAGE", isNewMessage };
}
export function setThemeType(themeType) {
   return (dispatch) => {
      dispatch({ type: THEME_TYPE, themeType });
   };
}
export function setWidgetSettingsVisibility(areWidgetSettingsVisible) {
   return (dispatch) => {
      dispatch({ type: "ARE_SETTINGS_VISIBLE", areWidgetSettingsVisible });
   };
}

export function setThemeColor(themeColor) {
   return (dispatch) => {
      dispatch({ type: THEME_COLOR, themeColor });
   };
}

export function onNavStyleChange(navStyle) {
   return (dispatch) => {
      dispatch({ type: NAV_STYLE, navStyle });
   };
}

export function switchLanguage(locale) {
   return (dispatch) => {
      dispatch({
         type: "SWITCH_LANGUAGE",
         payload: locale
      });
   };
}

export function updateSearchParams(params) {
   return (dispatch) => {
      dispatch({ type: "SET_SEARCH_PARAMS", payload: params });
   };
}

export const setAllLanguages = (data) => {
   return {
      type: "SET_ALL_LANGUAGES",
      payload: data
   };
};
export const setActiveCasesFolder = (folder) => {
   return {
      type: "SET_ACTIVE_CASES_FOLDER",
      payload: folder
   };
};
